(ns manage.adset-decision-tree-page.node-library
  (:require ["src/svg/arrows/arrow-clockwise-2.svg$default" :as ArrowClockwise2]
            ["src/svg/controls/target.svg$default" :as Target]
            ["src/svg/devices/server-network.svg$default" :as ServerNetwork]
            ["src/svg/devices/smartphone-gen-2.svg$default" :as Smartphone]
            ["src/svg/files_folders/file-spreadsheet.svg$default" :as FileSpreadsheet]
            ["src/svg/inform/plus.svg$default" :as Plus]
            ["src/svg/location/map-marker.svg$default" :as MapMarker]
            ["src/svg/location/poi.svg$default" :as POI]
            ["src/svg/objects/clock.svg$default" :as Clock]
            ["src/svg/objects/megaphone.svg$default" :as Megaphone]
            ["src/svg/organisations/other/meta.svg$default" :as Meta]
            ["src/svg/organisations/other/tiktok.svg$default" :as Tiktok]
            ["src/svg/path/path-split-right.svg$default" :as PathSplitRight]
            ["src/svg/person/person-3.svg$default" :as Person3]
            ["src/svg/type/tasks/roadmap.svg$default" :as Roadmap]
            ["src/svg/weather/cloud.svg$default" :as Cloud]
            [manage.adset-decision-tree-page.schema-urn :as schema-urn]
            [mate.core :as mc]))

(def node-type-ns "decision-tree-node")

(def category-defaults {:decision-node {:has-outcomes true}
                        :outcome-node {:has-variants true}})

(def node-control-mapping {:on-duplicate {:label "Duplicate"}
                           :on-delete {:label "Delete"}
                           :on-add-outcome {:label "Add Outcome"
                                            :icon Plus}
                           :on-refresh {:label "Refresh Outcomes"
                                        :icon ArrowClockwise2}})

(def channels-with-defaults #{"display" "video" "ctv"})

(def nodes
  (->> [{:type :decision-tree-node/root
         :category :root-node
         :name "Creative strategy"
         :description "Drag a node to expand your strategy."
         :icon Roadmap
         :raw-icon true
         :draggable false
         :deletable false
         :has-variants true
         :variant-properties {"meta" {}
                              "tiktok" {}
                              :default {:label "Default"
                                        :empty-text "No default selected"
                                        :hide-add-button true}}
         :properties [{:id :meta.facebook/platform-settings-warning
                       :adset-channel #{"meta"}}
                      {:id :meta.facebook/adset-id
                       :adset-channel #{"meta"}}
                      {:id :tiktok/tiktok-ad-group-id
                       :adset-channel #{"tiktok"}}]}

        {:type :decision-tree-node/meta-location
         :deprecated true
         :category :decision-node
         :outcome-node-type :decision-tree-node/meta-location-outcome
         :name "Location"
         :description "Target based on region, city, or postal code."
         :icon MapMarker}

        {:type :decision-tree-node/meta-location-outcome
         :deprecated true
         :category :outcome-node
         :decision-node-type :decision-tree-node/meta-location
         :label "Location"
         :properties [{:id :node/label}
                      {:id :meta.facebook/adset-id}]}

        {:type :decision-tree-node/date-time
         :category :decision-node
         :outcome-node-type :decision-tree-node/date-time-outcome
         :name "Date & Time"
         :description "Target based on time of day and day of the week"
         :icon Clock
         :properties [{:id :meta/timezone
                       :adset-channel #{"meta"}}
                      {:id :tiktok/timezone
                       :adset-channel #{"tiktok"}}]}

        {:type :decision-tree-node/date-time-outcome
         :category :outcome-node
         :decision-node-type :decision-tree-node/date-time
         :label "Date & Time"
         :properties [{:id :node/label}
                      {:id :targeting/predicate
                       :context {:type :predicate-schema
                                 :schema-urn schema-urn/datetime}}]}

        {:type :decision-tree-node/meta-audience
         :deprecated true
         :category :decision-node
         :outcome-node-type :decision-tree-node/meta-audience-outcome
         :name "Audience"
         :description "Target based on audience groups."
         :icon Target}

        {:type :decision-tree-node/meta-audience-outcome
         :deprecated true
         :category :outcome-node
         :decision-node-type :decision-tree-node/meta-audience
         :label "Audience"
         :properties [{:id :node/label}
                      {:id :meta.facebook/adset-id}]}

        {:type :decision-tree-node/weather
         :category :decision-node
         :outcome-node-type :decision-tree-node/weather-outcome
         :name "Weather"
         :description "Target based on weather conditions."
         :icon Cloud
         :properties [{:id :meta/lat-lon
                       :adset-channel #{"meta"}}]}

        {:type :decision-tree-node/weather-outcome
         :category :outcome-node
         :decision-node-type :decision-tree-node/weather
         :label "Weather"
         :properties [{:id :node/label}
                      {:id :targeting/predicate
                       :context {:type :predicate-schema
                                 :schema-urn schema-urn/weather}}]}

        {:type :decision-tree-node/meta-config
         :category :decision-node
         :outcome-node-type :decision-tree-node/meta-config-outcome
         :name "Meta Configuration"
         :description "Target based on Meta Adset"
         :icon Meta
         :adset-channel #{"meta"}}

        {:type :decision-tree-node/meta-config-outcome
         :category :outcome-node
         :decision-node-type :decision-tree-node/meta-config
         :label "Meta Configuration"
         :properties [{:id :meta.facebook/platform-settings-warning}
                      {:id :node/label}
                      {:id :meta.facebook/adset-id}
                      {:id :meta.facebook/lead-generation-form-id
                       :feature-flag :meta-form-id-configuration}]
         :adset-channel #{"meta"}}

        {:type :decision-tree-node/tiktok-config
         :category :decision-node
         :outcome-node-type :decision-tree-node/tiktok-config-outcome
         :name "TikTok Configuration"
         :description "Target based on TikTok Adset"
         :icon Tiktok
         :adset-channel #{"tiktok"}}

        {:type :decision-tree-node/tiktok-config-outcome
         :category :outcome-node
         :decision-node-type :decision-tree-node/tiktok-config
         :label "TikTok Configuration"
         :properties [{:id :node/label}
                      {:id :tiktok/tiktok-ad-group-id}]
         :adset-channel #{"tiktok"}}

        {:type :decision-tree-node/locale
         :category :decision-node
         :outcome-node-type :decision-tree-node/locale-outcome
         :name "Locale"
         :description "Target based on the preferred local language."
         :icon Megaphone
         :adset-channel #{"display" "video" "ctv"}}

        {:type :decision-tree-node/locale-outcome
         :category :outcome-node
         :decision-node-type :decision-tree-node/locale
         :label "Locale"
         :properties [{:id :node/label}
                      {:id :targeting/predicate
                       :context {:type :predicate-schema
                                 :schema-urn schema-urn/locale}}]
         :adset-channel #{"display" "video" "ctv"}}

        {:type :decision-tree-node/location
         :category :decision-node
         :outcome-node-type :decision-tree-node/location-outcome
         :name "Location"
         :description "Target based on the consumer's Location."
         :icon MapMarker
         :adset-channel #{"display" "video" "ctv"}}

        {:type :decision-tree-node/location-outcome
         :category :outcome-node
         :decision-node-type :decision-tree-node/location
         :label "Location"
         :properties [{:id :node/label}
                      {:id :targeting/predicate
                       :context {:type :predicate-schema
                                 :schema-urn schema-urn/location}}]
         :adset-channel #{"display" "video" "ctv"}}

        {:type :decision-tree-node/device
         :category :decision-node
         :outcome-node-type :decision-tree-node/device-outcome
         :name "Device"
         :description "Target based on the consumer's device."
         :icon Smartphone
         :adset-channel #{"display"}}

        {:type :decision-tree-node/device-outcome
         :category :outcome-node
         :decision-node-type :decision-tree-node/device
         :label "Device"
         :properties [{:id :node/label}
                      {:id :targeting/predicate
                       :context {:type :predicate-schema
                                 :schema-urn schema-urn/device}}]
         :adset-channel #{"display" "video" "ctv"}}

        {:type :decision-tree-node/audience
         :category :decision-node
         :outcome-node-type :decision-tree-node/audience-outcome
         :name "Audience"
         :description "Target based on Audience segment."
         :icon Person3
         :adset-channel #{"display" "video" "ctv"}}

        {:type :decision-tree-node/audience-outcome
         :category :outcome-node
         :decision-node-type :decision-tree-node/audience
         :label "Audience"
         :properties [{:id :node/label}
                      {:id :targeting/predicate
                       :context {:type :predicate-schema
                                 :schema-urn schema-urn/dsp-data}
                       :allowed-schema-keys #{:dsp-lineid
                                              :dsp-dealid
                                              :dsp-publisherid
                                              :dsp-site-url
                                              :dsp-placementid
                                              :dsp-linecode}}]
         :adset-channel #{"display" "video" "ctv"}}

        {:type :decision-tree-node/dsp-signal
         :category :decision-node
         :outcome-node-type :decision-tree-node/dsp-signal-outcome
         :name "DSP Signal"
         :description "Target based on advanced data from any DSP."
         :icon ServerNetwork
         :adset-channel #{"display" "video" "ctv"}}

        {:type :decision-tree-node/dsp-signal-outcome
         :category :outcome-node
         :decision-node-type :decision-tree-node/dsp-signal
         :label "DSP Signal"
         :properties [{:id :node/label}
                      {:id :targeting/predicate
                       :context {:type :predicate-schema
                                 :schema-urn schema-urn/dsp-data}}]
         :adset-channel #{"display" "video" "ctv"}}

        {:type :decision-tree-node/poi
         :category :decision-node
         :outcome-node-type :decision-tree-node/poi-outcome
         :name "POI"
         :description "Target based on nearby POI."
         :icon POI
         :properties [{:id :poi/properties}]
         :adset-channel #{"display" "video" "ctv"}
         :feature-flag :poi}

        {:type :decision-tree-node/poi-outcome
         :category :outcome-node
         :decision-node-type :decision-tree-node/poi
         :label "POI"
         :properties [{:id :node/label}
                      {:id :targeting/poi-predicate
                       :context {:type :predicate-schema
                                 :schema-urn schema-urn/poi}}]
         :adset-channel #{"display" "video" "ctv"}}

        {:type :decision-tree-node/dynamic-feed
         :category :decision-node
         :enable-refresh true
         :outcome-properties {:disable-addition true
                              :empty-text "Strategy outcomes will be displayed here once your feed has been configured."}
         :outcome-node-type :decision-tree-node/dynamic-feed-outcome
         :name "Feed"
         :description "Target based on advanced data from any feed."
         :icon FileSpreadsheet
         :properties [{:id :feed/properties
                       :has-save-button true}]
         :disable-side-panel-autosave true}

        {:type :decision-tree-node/dynamic-feed-outcome
         :category :outcome-node
         :disable-duplication true
         :decision-node-type :decision-tree-node/dynamic-feed
         :label "Feed outcome"
         :properties [{:id :node/label}
                      {:id :feed/outcome-source}
                      {:id :targeting/predicate :allow-any-trigger true :disabled true}]}

        {:type :decision-tree-node/variants-rotation-weighted
         :category :decision-node
         :palette false
         :name "Ad Variant Rotation"
         :description "Ad Variant Rotation"
         :icon PathSplitRight
         :outcome-node-type :decision-tree-node/variants-rotation-weighted-outcome}

        {:type :decision-tree-node/variants-rotation-weighted-outcome
         :category :outcome-node
         :palette false
         :has-variants false
         :decision-node-type :decision-tree-node/variants-rotation-weighted
         :label "Path"
         :properties [{:id :node/label}]}

        {:type :decision-tree-node/variants-rotation
         :category :decision-node
         :palette false
         :name "Ad variants rotation"
         :description "Ad variants rotation"
         :icon PathSplitRight
         :outcome-node-type :decision-tree-node/variants-rotation-outcome}

        {:type :decision-tree-node/variants-rotation-outcome
         :category :outcome-node
         :palette false
         :has-variants false
         :decision-node-type :decision-tree-node/variants-rotation
         :label "Path"
         :properties [{:id :node/label}]}]
       (map (fn [{:keys [category] :as node}]
              (merge (get category-defaults category) node)))))

(def type->node
  (mc/index-by :type nodes))
